// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HEF-1mKYCSSUbwTYQDhLnw\\=\\={width:450px;padding-top:var(--xds-spacing-d);background:var(--xds-color-container-subtle)}", "",{"version":3,"sources":["webpack://./src/pages/Couriers/components/CourierDialogPopup/CourierDialogPopup.module.scss"],"names":[],"mappings":"AAAA,4BACE,WAAA,CACA,gCAAA,CACA,4CAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"courierDialogPopup": "HEF-1mKYCSSUbwTYQDhLnw=="
};
export default ___CSS_LOADER_EXPORT___;
